import { orderBy, table, viewId } from '../../../../_constants/Code'
import { PathInfoList } from '../../../../_constants/PathInfoList'
import { errorLog } from '../../../../common/logger/Logger'
import { getDynamoDB } from '../../../../common/utils/DynamoDbUtils'
import { getCsvByJson, getFileNameList, getObject } from '../../../../common/utils/FileUtils'
import { filterDataCreateTask } from '../../employeeCountInfo/extra/dataParsers'
import { fetchFiscalYearDateList } from '../../employeeCountInfo/extra/fiscalYearUtils'
import { fetchtDataCreateTask } from '../../employeeCountInfo/extra/services'

export const fetchJsonData = async (props) => {
  try {
    // 年収計算設定情報取得
    let fileData = await getObject(
      props.bucketName,
      PathInfoList.Folder.annualIncomeCalculationFolder + PathInfoList.Objectkeyname.annualIncomeCalculation
    )
    fileData = new File([fileData], PathInfoList.Objectkeyname.annualIncomeCalculation, { type: 'text/csv' })
    const jsonData = await getCsvByJson(fileData) // blobからjsonに変換

    return jsonData
  } catch (error) {
    errorLog('E000001', props.userId, viewId.annualIncomeCalculationInfo, 'fetchJsonData', error)
  }
}

/**
 * マスター情報取得関数
 *
 * @returns {Promise<Object>} 取得したマスター情報
 */
export const fetchMasterData = async (props) => {
  try {
    const masterData = await getDynamoDB(
      table.Master,
      null,
      props.corporationNumber,
      { CorporationNumber: props.corporationNumber, MasterId: viewId.annualIncomeCalculationInfo },
      null
    )
    return masterData[0]
  } catch (error) {
    errorLog('E000001', props.userId, viewId.annualIncomeCalculationInfo, 'fetchMasterData', error)
  }
}

/** 年度リスト取得関数 S3内のファイル名から年度リストを作成する */
export const fetchFiscalYearList = async (currentYear, props) => {
  try {
    const { corporationNumber, accPeriod } = props
    const dataCreateTask = await fetchtDataCreateTask(corporationNumber, corporationNumber)
    const annualTask = filterDataCreateTask(dataCreateTask, accPeriod)
    const fiscalYearDataList = fetchFiscalYearDateList(annualTask, accPeriod)

    return fiscalYearDataList.map((e) => e.fiscalYear)

    // 前処理

    // const fileList = await getFileNameList(props.bucketName, baseKey + fileKey, orderBy.asc)

    // const currentYearInt = parseInt(currentYear.replace('年度', ''), 10)
    // let startYear

    // if (fileList.length) {
    //   startYear = parseInt(
    //     fileList
    //       .map((item) => item.split('_')[0])
    //       .filter((item) => !isNaN(item))
    // .sort((a, b) => parseInt(a, 10) - parseInt(b, 10))[0],
    //     10
    //   )
    // } else {
    //   // ファイルが存在しない場合、開始年度は現在の年度とする
    //   startYear = currentYearInt
    // }
    // // 開始年度から現在年度+5年までの年度リストを逆順で作成
    // const yearList = []
    // for (let year = startYear; year <= currentYearInt + 5; year++) {
    //   yearList.unshift(`${year}年度`)
    // }

    // return yearList
  } catch (error) {
    errorLog('E000001', props.userId, viewId.annualIncomeCalculationInfo, 'fetchFiscalYearList', error)
    return []
  }
}
